import styled from 'styled-components';

export const CartItemButton = styled.button`
  border: 0;
  padding: 0.75rem;
  font-family: ${Styles.fontFamily.base};
`;
